import { render, staticRenderFns } from "./TaskPanel.vue?vue&type=template&id=6e8d7b1c&scoped=true&lang=pug"
import script from "./TaskPanel.vue?vue&type=script&lang=js"
export * from "./TaskPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskPanel.vue?vue&type=style&index=0&id=6e8d7b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d7b1c",
  null
  
)

export default component.exports